export default __webpack_public_path__ + "static/media/ball_1.b9829882.png";